module.exports = __webpack_public_path__ + "img/Flecha_verde_derecha.62d07bf7.svg";